<!-- 组件说明 -->
<template>
  <div class="">
    <!-- 已经尽力做到跟UI图一样了，还是有一些细节没有跟上，一个一个查API头大 -->
    <div ref="chart" class="chart"></div>
    <!-- 测试修改 -->
    <!-- <button @click="resize">resize</button> -->
  </div>
</template>

<script>
import echarts from "@/lib/echarts";
export default {
  props: {
    allStatusStatistical: {
      type: Array,
    },
  },
  data() {
    return {
      myChart: null,
      barData: [],
      lineData: [],
      monthData: [],
    };
  },
  computed: {
    options() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
        },
        legend: {
          data: ["套数", "比例"],
          bottom: "10",
          //   itemHeight: "3",
          itemHeight: "6",
        },
        xAxis: [
          {
            type: "category",
            data: this.monthData,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                type: "dashed",
                color: "#979797",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "套数",
            axisLine: {
              show: false,
              lineStyle: {},
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            nameTextStyle: {
              color: "#999999",
              align: "right",
            },
            axisLabel: {
              color: "#999999",
            },
            splitNumber: 4,
            minInterval: 1,
          },
          {
            type: "value",
            name: "比例",
            axisLabel: {
              formatter: "{value}%",
              color: "#999999",
            },
            axisLine: {
              show: false,
              lineStyle: {},
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              color: "#999999",
              align: "left",
            },
            splitNumber: 4,
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "套数",
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#1EC9A2",
                  },
                  {
                    offset: 1,
                    color: "#0D9869",
                  },
                ]),
              },
            },
            barWidth: "6px",
            data: this.barData,
          },
          {
            name: "比例",
            type: "line",
            itemStyle: {
              color: "#E8AF46",
            },
            yAxisIndex: 1,
            data: this.lineData,
          },
        ],
      };
    },
  },
  methods: {
    getEchartData() {
      const chart = this.$refs.chart;
      if (chart) {
        this.myChart = echarts.init(chart);
        const option = { ...this.options };
        this.myChart.setOption(option);
        // window.addEventListener("resize", function() {
        //   this.myChart.resize();
        // });
      }
      //   this.$on("hook:destroyed", () => {
      //     window.removeEventListener("resize", function() {
      //       this.myChart.resize();
      //     });
      //   });
    },
    // 排序方法
    compare(property) {
      return function(a, b) {
        var value1 = parseInt(a[property]);
        var value2 = parseInt(b[property]);
        return value1 - value2;
      };
    },
    // 将大数据传来的数据格式化
    rebuildData() {
      let allStatusStatistical = JSON.parse(
        JSON.stringify(this.allStatusStatistical)
      );

      // 按月份排序
      allStatusStatistical.sort(this.compare("month"));
      this.monthData = [];
      this.barData = [];
      this.lineData = [];
      // 三项赋值
      allStatusStatistical.forEach((res) => {
        this.monthData.push(parseInt(res.month) + "月");
        this.barData.push(parseFloat(res.currentMonthTotal));
        this.lineData.push(
          Math.floor(res.currentMonthPercentage * 10000) / 100
        );
      });
    },
  },
  watch: {
    // 重载图表
    options(val) {
      this.myChart.setOption(val, true);
    },
    // 数据变更格式化
    allStatusStatistical() {
      this.rebuildData();
    },
  },
  mounted() {
    // 初始化
    this.getEchartData();
  },
};
</script>

<style lang="scss" scoped>
.chart {
  width: 690px;
  height: 482px;
}
</style>
